import classNames from "classnames";
import { IconButton } from "src/components/IconButton/IconButton";
import ScanningActive from "../../../navigation/AppStatusBar/ScanningIcon/scanning-active.svg?react";
import ScanningError from "../../../navigation/AppStatusBar/ScanningIcon/scanning-error.svg?react";
import ScanningSuccess from "../../../navigation/AppStatusBar/ScanningIcon/scanning-success.svg?react";

interface IStatusIconProps {
  className?: string;
  state?: "pending" | "conflict" | "success" | "failed";
  tooltipMessage?: string;
}

export const StatusIcon = (props: IStatusIconProps): JSX.Element => {
  //const theme = useTheme();
  //const classes = useStyles(theme);
  const { className, state, tooltipMessage } = props;

  return (
    <div className={className}>
      <IconButton tooltipProps={{ title: tooltipMessage }} size="small">
        {state === "pending" && <ScanningActive className={classNames("pending", "icon_foreground")} />}
        {state === "success" && <ScanningSuccess className={classNames("success", "icon_foreground")} />}
        {state === "conflict" && <ScanningError className={classNames("conflict", "icon_foreground")} />}
        {state === "failed" && <ScanningError className={classNames("failed", "icon_foreground")} />}
      </IconButton>
    </div>
  );
};
